import React, { Component } from "react";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";
import { connect } from "react-redux";

import { ActionCreator } from "../../../../../../../actions/actions";
import { HallsActionCreators } from "../../../../../actions/actionCreators";

import "./LicenseIdConfirmation.component.scss";

export interface LicenseIdConfirmationProps {
    serverId: number;
    rejectLicenseID: ActionCreator;
    confirmLicenseID: ActionCreator;
}

class LicenseIdConfirmation extends Component<LicenseIdConfirmationProps, {}> {
    render() {
        return (
            <React.Fragment>
                <div id="LicenseIdConfirmation">
                    <div className="mgmt-info">
                        <p>
                            The uploaded seed has a new or different Id. To continue
                            please confirm that you want to proceed with this
                            upload. In alternative restart the process to
                            upload a new seed.
                        </p>
                    </div>
                    <div>
                        <div className="input-and-button">
                            <div>
                                <button
                                    className="btn cancel-btn"
                                    onClick={() => {
                                        this.props.rejectLicenseID({
                                            serverId: this.props.serverId
                                        });
                                    }}
                                >
                                    Reject
                                </button>
                            </div>
                            <div>
                                <button
                                    className="red-btn confirm-btn"
                                    onClick={() => {
                                        this.props.confirmLicenseID({
                                            serverId: this.props.serverId
                                        });
                                    }}
                                >
                                    Confirm Change
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {
    rejectLicenseID: HallsActionCreators.rejectLicenseID,
    confirmLicenseID: HallsActionCreators.confirmLicenseID
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LicenseIdConfirmation);
